import { AuthProvider } from "@pankod/refine-core";
import * as authApis from "apis/auth";
import { LoginPayload } from "apis/auth";
import { setLocalStorage } from "helpers/local-storage";
import {
  AVATAR,
  JWT_TOKEN_LOCAL,
  REFRESH_TOKEN_LOCAL,
  USERNAME,
} from "./../constants";
import axiosService from "./axios.service";

export const authProvider: AuthProvider = {
  login: async (payload: LoginPayload) => {
    const data = await authApis.login(payload);
    setLocalStorage(JWT_TOKEN_LOCAL, data?.accessToken);
    setLocalStorage(REFRESH_TOKEN_LOCAL, data?.refreshToken);
    setLocalStorage(USERNAME, data?.username);
    setLocalStorage(AVATAR, data?.avatar);

    axiosService.setHeader("Authorization", `Bearer ${data?.accessToken}`);

    window.location.href = "/users";
    return Promise.resolve();
  },
  logout: () => {
    localStorage.removeItem(JWT_TOKEN_LOCAL);
    localStorage.removeItem(REFRESH_TOKEN_LOCAL);
    return Promise.resolve();
  },
  checkError: () => Promise.resolve(),
  checkAuth: () => {
    const token = localStorage.getItem(JWT_TOKEN_LOCAL);
    if (token) {
      return Promise.resolve();
    }

    return Promise.reject();
  },
  getPermissions: () => Promise.resolve(),
  getUserIdentity: async () => {
    const username = localStorage.getItem(USERNAME);
    const avatar = localStorage.getItem(AVATAR);
    if (username && avatar) {
      const parsedUsername = JSON.parse(username);
      const parsedAvatar = JSON.parse(avatar);
      return Promise.resolve({
        username: parsedUsername,
        avatar: parsedAvatar,
      });
    }
    return Promise.reject();
  },
};
